import React from 'react'

const House = ({color}) => {
  return (
    <svg viewBox="0 0 28 26">
      <path
        fill={color}
        d="M27.6,10.6l-3.7-2.9V2.6c0-0.6-0.4-1-1-1h-3.8c-0.6,0-1,0.4-1,1V3l-3.5-2.8c-0.4-0.3-0.9-0.3-1.2,0L4.1,7.7
	C3.7,7.7,3.5,8,3.3,8.3l-3,2.4c-0.4,0.3-0.5,1-0.2,1.4c0.3,0.4,1,0.5,1.4,0.2l1.6-1.3V25c0,0.6,0.4,1,1,1h18.7c0.6,0,1-0.4,1-1V10.2
	l2.4,2c0.4,0.3,1.1,0.3,1.4-0.2C28.1,11.6,28.1,11,27.6,10.6z M17.1,24h-6.1v-7.6h6.1V24z M21.9,24h-2.9v-8.6c0-0.6-0.4-1-1-1H9.9
	c-0.6,0-1,0.4-1,1V24H5.3V9.3l8.8-7l7.9,6.3V24z M21.9,6.1l-1.8-1.5v-1h1.8V6.1z"/>
    </svg>
  )
}

export default House
